var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V15.0859L2.34277 10.4287C1.95223 10.0385 1.31914 10.0383 0.928712 10.4287C0.538286 10.8191 0.538485 11.4522 0.928712 11.8428L7.29297 18.207C7.68349 18.5976 8.31651 18.5976 8.70703 18.207L15.0713 11.8428C15.4615 11.4522 15.4617 10.8191 15.0713 10.4287C14.6809 10.0383 14.0478 10.0385 13.6572 10.4287L9 15.0859V1Z",
    fill: "#0CC44D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGreen);
export default __webpack_public_path__ + "static/media/arrow-down-green.0a4011ba91970f9c8d845c998380293d.svg";
export { ForwardRef as ReactComponent };